/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import Media from 'react-media';
import { useQuery } from '@apollo/client';
import {
    func, string,
    arrayOf, shape, number, bool,
} from 'prop-types';

import CUSTOM_BREAKPOINTS from '../../../style/customBreakpoints';
import MobileSubscriptionDetail from './MobileSubscriptionDetail';
import DesktopSubscriptionDetail from '../DesktopSubscriptions/DesktopSubscriptionDetail';
import findSkuByPartNumbers from '../../../../../gql/queries/findSkuByPartNumbers';

const SubscriptionDetail = ({
    subscriptionRuleId, selectedSubscription, handleCancel, handleUpdate, featureFlags, updateSubscriptionList, enableEditButton,
}) => {
    const [mobileAgeVerificationOpen, setMobileAgeVerificationOpen] = useState(false);
    const breakpointExpr = `(min-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;
    const brandByDomain = {
        1001: '1800flowers',
        1019: 'harryanddavid',
        1009: '1800baskets',
        1025: 'simplychocolate',
        1010: 'fruitbouquets',
        1012: 'cheryls',
        1022: 'personalizationuniverse',
        1002: 'thepopcornfactory',
        1020: 'wolfermans',
        1018: 'stockyards',
        1030: 'personalizationmall',
        1031: 'vitalchoice',
        1033: 'thingsremembered',
        1034: 'florists',
    };
    const QUERY = findSkuByPartNumbers(
        brandByDomain[selectedSubscription?.brand],
        `["${selectedSubscription?.brand}-${selectedSubscription?.productId}"]`,
        `id
        name
        brand
        brandId
        baseCode
        partNumber
        productType
        minAge
        ageVerifyFlag
        parentProduct {
          partNumber
          name
        }`,
    );
    const { data } = useQuery(QUERY);
    const selectedSku = data?.findSkuByPartNumbers?.[0] || {};

    const handleMobileAgeVerification = (flag) => {
        setMobileAgeVerificationOpen(flag);
    };

    return (
        <Media query={breakpointExpr}>
            {(matches) => (
                matches ? (
                    <DesktopSubscriptionDetail
                        selectedSku={selectedSku}
                        handleCancel={handleCancel}
                        handleUpdate={handleUpdate}
                        featureFlags={featureFlags}
                        enableEditButton={enableEditButton}
                        subscriptionRuleId={subscriptionRuleId}
                        selectedSubscription={selectedSubscription}
                        updateSubscriptionList={updateSubscriptionList}
                        mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                        handleMobileAgeVerification={handleMobileAgeVerification}
                    />
                ) : (
                    <MobileSubscriptionDetail
                        selectedSku={selectedSku}
                        handleCancel={handleCancel}
                        handleUpdate={handleUpdate}
                        featureFlags={featureFlags}
                        enableEditButton={enableEditButton}
                        subscriptionRuleId={subscriptionRuleId}
                        selectedSubscription={selectedSubscription}
                        updateSubscriptionList={updateSubscriptionList}
                        mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                        handleMobileAgeVerification={handleMobileAgeVerification}
                    />
                )
            )}
        </Media>
    );
};

SubscriptionDetail.defaultProps = {
    selectedSubscription: null,
    handleCancel: () => {},
    handleUpdate: () => {},
    subscriptionRuleId: '',
};

SubscriptionDetail.propTypes = {
    selectedSubscription: arrayOf(
        shape({
            checkoutBrand: string,
            duration: number.isRequired,
            endDate: string.isRequired,
            interval: number.isRequired,
            nextOrderDate: string,
            orderDate: string.isRequired,
            orderHistoryResult: arrayOf(
                shape({
                    deliveryDate: string,
                    discountAmount: string,
                    orderDate: string.isRequired,
                    orderNumber: string.isRequired,
                    productCode: string.isRequired,
                    productName: string.isRequired,
                    productPrice: string.isRequired,
                    quantity: string.isRequired,
                }),
            ),
            orderNumber: string.isRequired,
            orderTime: string.isRequired,
            orderType: string.isRequired,
            price: string.isRequired,
            productId: string.isRequired,
            productImageCategory: string.isRequired,
            productImageThumbnail: string.isRequired,
            productName: string.isRequired,
            quantity: string,
            recipient: arrayOf(shape({
                city: string.isRequired,
                country: string.isRequired,
                firstName: string.isRequired,
                lastName: string.isRequired,
                state: string.isRequired,
                street1: string.isRequired,
                street2: string.isRequired,
                zipcode: string.isRequired,
            })),
            ruleId: string.isRequired,
            startDate: string.isRequired,
            subscriptionStatus: string.isRequired,
            totalAmount: string.isRequired,
        }),
    ),
    updateSubscriptionList: func.isRequired,
    enableEditButton: func.isRequired,
    handleCancel: func,
    handleUpdate: func,
    subscriptionRuleId: string,
    featureFlags: shape({
        'is-subscription-skip': bool,
        'is-subscription-pause': bool,
        'is-subscription-frequency': bool,
    }).isRequired,
};

export default SubscriptionDetail;
